<div class="recomendations-container" *ngIf="recommendedFoods || recommendedDrinks" >
    <div class="recomendations-container__title">{{ 'together' | translate }}</div>
    <div class="recomendations-slider"
        [ngStyle]="{
            'height.px': height + 4,
        }">

        <!-- foods -->
        <div *ngFor="let food of recommendedFoods">
            <app-menu-recomendation-card-food
              [food]="food">
            </app-menu-recomendation-card-food>
        </div>

        <!-- drinks -->
        <div *ngFor="let drink of recommendedDrinks">
            <app-menu-recomendation-card-drink
              [drink]="drink">
            </app-menu-recomendation-card-drink>
        </div>
    </div>
</div>